/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Delete_Empty_HintInputs */

const cs_settings_teams_delete_empty_hint = /** @type {(inputs: Settings_Teams_Delete_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento tým nemá žádné členy, takže není třeba nikoho přesouvat.`)
};

const en_settings_teams_delete_empty_hint = /** @type {(inputs: Settings_Teams_Delete_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This team has no members, so nothing needs to be reassigned.`)
};

/**
* | output |
* | --- |
* | "This team has no members, so nothing needs to be reassigned." |
*
* @param {Settings_Teams_Delete_Empty_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_delete_empty_hint = /** @type {((inputs?: Settings_Teams_Delete_Empty_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Delete_Empty_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_delete_empty_hint(inputs)
	return cs_settings_teams_delete_empty_hint(inputs)
});